import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';

import { TranslocoModule } from '@ngneat/transloco';

import { IconModule } from '@shared/icon/icon.module';
import { MaterialModule } from '@shared/material.module';

import { ChipsMultiSelectComponent } from './chips-multi-select.component';

@NgModule({
    declarations: [ChipsMultiSelectComponent],
    imports: [
        CommonModule,
        TranslocoModule,
        FormsModule,
        MaterialModule,
        FlexLayoutModule,
        IconModule,
        MatChipsModule,
    ],

    exports: [ChipsMultiSelectComponent],
})
export class ChipsMultiSelectModule {}
